$mol_svg_path $mol_svg
	dom_name \path
	attr *
		^
		d <= geometry \

